<app-toasts-container></app-toasts-container>
<div class="fixed-layout">
  <app-header [showItems]="false" ></app-header>
</div>
<div class="movie-full-background">
  <div class="main-container">
  </div>
</div>
